import React from 'react';

import { pick } from 'es-toolkit';

import { useInboxItemsQueryVariables } from '../inboxItem';

export const useReportItemsFilter = () => {
  const { where } = useInboxItemsQueryVariables();

  return React.useMemo(
    () => ({
      filter: {
        inboxItem: where ? pick(where, ['type']) : undefined,
      },
    }),
    [where],
  );
};
